// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2RP3C","footer":"ModalCreateQualiphyProcedure_footer__22PP1","additionData":"ModalCreateQualiphyProcedure_additionData__NLTY2"};